import { useCallback, useRef } from "react";

/** A stable function identity that always invokes the latest `fn`. */
export function useCallbackRef<A extends unknown[]>(fn: (...args: A) => void): (...args: A) => void {
  const ref = useRef(fn);
  ref.current = fn;
  return useCallback((...args: A) => ref.current(...args), []);
}
